import AmexFranchiseEditorials from './AmexFranchiseEditorials';

export default AmexFranchiseEditorials;
